// src/pages/DashboardHome.jsx
import React, { useState, useEffect } from 'react';
import { useGlobalContext } from '../GlobalContext';
import { Bar } from 'react-chartjs-2';

const DashboardHome = () => {
  //let tahun, bulan ;
  const { periode, nama, isReady, api } = useGlobalContext();
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (isReady) {
     getPiutang();    
    } 
  }, [isReady]);

  const getPiutang = async () => {
    try {
      const response = await api.get(`/api/transaksi/rekpinjamanpiutang/${periode}`);
      const selectData = response.data || [];
      selectData.sort((a, b) => a.periode.localeCompare(b.periode));
      setChartData(selectData);
    } catch (error) {
      console.error('Gagal mengambil data piutang:', error);
    }
  }  

  const labels = chartData.map(item => {
    const tahun = item.periode.substring(0, 4);
    const bulan = item.periode.substring(4, 6);
    return `${bulan}/${tahun}`; // format MM/YYYY
  });

  const dataPiutang = chartData.map(item =>  (item.totalpiutang / 1_000_000).toFixed(1));

  const stackedBarChartData = {
    labels,
    datasets: [
      {
        label: 'Total Piutang',
        backgroundColor: '#f56954',
        data: dataPiutang,
      },
    ],
  };

  const options = { responsive: true, maintainAspectRatio: false, plugins: { legend: { position: 'top' } } };
    const stackedOptions = { ...options, scales: { x: { stacked: true,  barPercentage: 0.2,
      categoryPercentage: 0.5 }, y: { stacked: true } } }
  ;

  return (
    <div className="wrapper">
      <section className="content">
        <div className="container-fluid">
          <b>
            <h6 style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              PERIODE
              <span style={{ marginLeft: '15px' }}>: {periode} </span>
              <span style={{ marginLeft: "auto" }}>USER : {nama}</span>
            </h6>
          </b>
        </div>
      </section>
      <br/>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {/* STACKED BAR CHART */}
            <div className="col-md-6">
              <div className="card card-success">
                <div className="card-header">
                  <h2 className="card-title">STACED BAR CHART</h2>
                  <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-card-widget="collapse">
                      <i className="fas fa-minus" />
                    </button>
                    <button type="button" className="btn btn-tool" data-card-widget="remove">
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="chart" style={{ height: 250 }}>
                    <Bar data={stackedBarChartData} options={stackedOptions} height={250} />
                    {/*<canvas id="stackedBarChart" style={{minHeight: 250, height: 300, maxHeight: 300, maxWidth: '100%'}} />*/}
                  </div>
                </div>
              </div>
            </div>  
          </div>  
        </div>
      </section>  
    </div>
  );
};

export default DashboardHome;
